import { secondsToMilliseconds } from 'date-fns'
import { timeRangeOrPeriodToTimeRange } from 'src/utility/time'
import useTimeRange from 'src/contexts/timeRange'
import { Button, TimePickerNavigation } from 'src/components/ui'
import { FetchModel } from 'src/services'
import { useTrainingPeriodStore } from 'models/model'
import { NEW } from '../../model.utils'

type Props = {
  model: FetchModel
}

export function ModelTimeNavigation({ model }: Props): JSX.Element {
  const { trainingPeriod } = useTrainingPeriodStore()
  const { timeRange, setTimeRange } = useTimeRange()
  const includedTime = timeRangeOrPeriodToTimeRange(trainingPeriod)
  const isTimeRangeModified =
    Math.abs(includedTime.from - timeRange.from) > secondsToMilliseconds(10) ||
    Math.abs(includedTime.to - timeRange.to) > secondsToMilliseconds(10)

  function handleTimeRangeReset(): void {
    setTimeRange(timeRangeOrPeriodToTimeRange(trainingPeriod))
  }

  return (
    <div className="flex w-full items-center justify-end gap-xs">
      {isTimeRangeModified && model.state === NEW && (
        <Button
          variant="tertiary"
          onClick={handleTimeRangeReset}
          title="Show Training Period"
        />
      )}
      <TimePickerNavigation />
    </div>
  )
}
